import {
  CLEAR_ERROR,
  PERMISSION_ERROR,
  GENERAL_ERROR,
  IMPORT_ERROR,
  SAVE_TEMP_FILE_ERROR,
} from '../constants/ActionTypes'

/**
 * @typedef {import('../index').PlottrFile} PlottrFile
 * @typedef {keyof PlottrFile} StoreKey
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @typedef {ReturnType<typeof permissionError> | ReturnType<typeof generalError> | ReturnType<typeof clearError> | ReturnType<typeof importError> | ReturnType<typeof saveTempFileError>} ErrorActions
 */

/**
 * NOTE(ed): We can't self-reference PltrAction in an action function,
 * so the action argument must be any.
 *
 * @param {StoreKey} storeKey,
 * @param {any} action
 * @param {String} error
 * @return {{ type: 'PERMISSION_ERROR', storeKey: StoreKey, action: any, error: String }}
 */
export const permissionError = (storeKey, action, error) => ({
  type: PERMISSION_ERROR,
  storeKey,
  action,
  error,
})

/**
 * @param {String} error
 * @return {{ type: 'GENERAL_ERROR', error: String }}
 */
export const generalError = (error) => ({
  type: GENERAL_ERROR,
  error,
})

/**
 * @return {{ type: 'CLEAR_ERROR' }}
 */
export const clearError = () => ({
  type: CLEAR_ERROR,
})

/**
 * @param {String} error
 * @return {{ type: 'IMPORT_ERROR', error: String }}
 */
export const importError = (error) => ({
  type: IMPORT_ERROR,
  error,
})

/**
 * @param {String} errorMessage
 * @return {{ type: 'SAVE_TEMP_FILE_ERROR', error: String }}
 */
export const saveTempFileError = (errorMessage) => ({
  type: SAVE_TEMP_FILE_ERROR,
  error: errorMessage,
})
